module.exports = __webpack_public_path__ + "06_medium_brown.aef0140e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/06_medium_brown.png
// module id = gYhZ
// module chunks = 0